import { FUND_MOVEMENT_TYPE_ENUM } from "types/fund-movements-history";

const STORAGE_KEY = "daf_movements_filters";

const VALID_TYPES = new Set<string>(Object.values(FUND_MOVEMENT_TYPE_ENUM));

export const ALL_MOVEMENT_TYPES: FUND_MOVEMENT_TYPE_ENUM[] = [
  FUND_MOVEMENT_TYPE_ENUM.CONTRIBUTION,
  FUND_MOVEMENT_TYPE_ENUM.GRANT,
  FUND_MOVEMENT_TYPE_ENUM.INVESTMENT,
  FUND_MOVEMENT_TYPE_ENUM.GRANTVESTMENT,
  FUND_MOVEMENT_TYPE_ENUM.GV_DISTRIBUTION,
  FUND_MOVEMENT_TYPE_ENUM.DISTRIBUTION,
  FUND_MOVEMENT_TYPE_ENUM.FEE,
  FUND_MOVEMENT_TYPE_ENUM.ADJUSTMENT,
  FUND_MOVEMENT_TYPE_ENUM.TRANSFER,
];

export function readMovementsFilters(): {
  year: number;
  types: string[];
} {
  const defaultYear = new Date().getFullYear();
  const defaultTypes = ALL_MOVEMENT_TYPES.map(String);
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { year: defaultYear, types: defaultTypes };
    }
    const parsed = JSON.parse(raw) as { year?: unknown; types?: unknown };
    const rawYear = parsed.year;
    const numericYear =
      typeof rawYear === "number"
        ? rawYear
        : typeof rawYear === "string" && /^\d{4}$/.test(rawYear)
          ? Number(rawYear)
          : NaN;
    const year =
      Number.isFinite(numericYear) && numericYear >= 1970
        ? Math.trunc(numericYear)
        : defaultYear;
    let types: string[];
    if (!Array.isArray(parsed.types)) {
      types = defaultTypes;
    } else {
      types = parsed.types.filter(
        (t): t is string => typeof t === "string" && VALID_TYPES.has(t)
      );
      if (types.length === 0) {
        types = defaultTypes;
      }
    }
    return { year, types };
  } catch {
    return { year: defaultYear, types: defaultTypes };
  }
}

export function writeMovementsFilters(year: number, types: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ year, types }));
  } catch {
    // ignore quota / private mode
  }
}
